import type * as THREE from 'three';
import type { Entity } from './Entity';
import type { EntityId } from '../types';

export class EntityRegistry {
  private readonly entities = new Map<EntityId, Entity>();

  constructor(private readonly sceneRoot: THREE.Object3D) {}

  add(entity: Entity): void {
    if (this.entities.has(entity.id)) return;
    this.entities.set(entity.id, entity);
    this.sceneRoot.add(entity.object3D);
    entity.onSpawn();
  }

  remove(id: EntityId): void {
    const entity = this.entities.get(id);
    if (!entity) return;
    entity.onDespawn();
    this.sceneRoot.remove(entity.object3D);
    this.entities.delete(id);
  }

  get(id: EntityId): Entity | undefined {
    return this.entities.get(id);
  }

  all(): ReadonlyMap<EntityId, Entity> {
    return this.entities;
  }

  update(dt: number): void {
    const deadIds: EntityId[] = [];
    for (const entity of this.entities.values()) {
      if (!entity.isAlive) {
        deadIds.push(entity.id);
        continue;
      }
      entity.update(dt);
    }
    for (const id of deadIds) this.remove(id);
  }

  clear(): void {
    for (const id of [...this.entities.keys()]) this.remove(id);
  }
}
